module.exports = __webpack_public_path__ + "static/media/6.c96a10f6.jpg";